import {useEffect, useRef} from 'react';

import {MapRef} from '~types/Map';
import useMapLoadedEffect from '~utils/map/events/useMapLoadedEffect';

export default function useMapSizeController(map: MapRef) {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const observer = useRef<MutationObserver | null>(null);

    useMapLoadedEffect((m) => m.resize(), map);

    useEffect(() => {
        if (!containerRef.current) {
            return;
        }

        observer.current = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    containerRef.current &&
                    map.current &&
                    mutation.attributeName === 'style' &&
                    window
                        .getComputedStyle(containerRef.current)
                        .getPropertyValue('display') !== 'none'
                ) {
                    map.current.resize();
                }
            });
        });

        observer.current.observe(containerRef.current, {
            attributes: true,
            attributeFilter: ['style'],
        });

        return () => {
            observer.current?.disconnect();
        };
    }, []);

    return containerRef;
}
